import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataSeriesValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'array',
            empty: false,
            mandatory: false
        };
    }
}
